import { render } from "./ProductionInfo.vue?vue&type=template&id=4dd8b902&scoped=true&ts=true"
import script from "./ProductionInfo.vue?vue&type=script&lang=ts"
export * from "./ProductionInfo.vue?vue&type=script&lang=ts"

import "./ProductionInfo.vue?vue&type=style&index=0&id=4dd8b902&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd8b902"]])

export default __exports__